import React, { ReactElement } from "react";
import { gql, MutationFunction, useMutation } from "@apollo/client";
import { CountOfferViewMutationMutation, CountOfferViewMutationMutationVariables } from "../../../schemaTypes";

export const countOfferViewMutation = gql`
  mutation CountOfferViewMutation(
    $offerId: String!
  ) {
    countOfferView(
      offerId: $offerId, 
    ){
      errors{
        path
        message
      }
      message
    }
  }
`;

export interface WithCountOfferView {
  countOfferView: MutationFunction<
    CountOfferViewMutationMutation,
    CountOfferViewMutationMutationVariables
  >;
}

interface Props {
  children: (data: WithCountOfferView) => ReactElement | null;
}

export const CountOfferView: React.FC<Props> = ({ children }) => {
  const [mutate] = useMutation<
    CountOfferViewMutationMutation,
    CountOfferViewMutationMutationVariables
  >(countOfferViewMutation);

  return children({ countOfferView: mutate });
};